import clsx from 'clsx';
import React from 'react';

export enum SectionColor {
  Gold = 'gold',
  Magenta = 'magenta',
  Black = 'black',
}

interface SectionBreakTitleProps {
  className?: string;
  color?: SectionColor;
  title: string;
  titleClassName?: string;
}

const SectionBreakTitle = ({
  className,
  color = SectionColor.Black,
  title,
  titleClassName,
}: SectionBreakTitleProps) => {
  const isGold = color === SectionColor.Gold;
  const isMagenta = color === SectionColor.Magenta;
  const isBlack = color === SectionColor.Black;

  return (
    <div className={clsx(className, 'flex')}>
      <h4
        className={clsx(
          titleClassName,
          'm-0 inline-block border-0 border-t border-solid pr-16 pt-8 font-suisse-intl-mono text-overline-md',
          {
            'border-pro-gold': isGold,
            'border-primary-magenta': isMagenta,
            'border-primary-black': isBlack,
          }
        )}
      >
        {title}
      </h4>
      <div className="relative flex-1 pb-4">
        <div
          className={clsx('absolute left-[11px] top-[-5px] h-[33px] w-px -rotate-[47deg]', {
            'bg-pro-gold': isGold,
            'bg-primary-magenta': isMagenta,
            'bg-primary-black': isBlack,
          })}
        />
        <div
          className={clsx('ml-[23px] h-full border-0 border-b border-solid ', {
            'border-pro-gold': isGold,
            'border-primary-magenta': isMagenta,
            'border-primary-black': isBlack,
          })}
        />
      </div>
    </div>
  );
};

export default SectionBreakTitle;
